import { render, staticRenderFns } from "./TheInviteRegister.vue?vue&type=template&id=24c3a7d4&"
import script from "./TheInviteRegister.vue?vue&type=script&lang=js&"
export * from "./TheInviteRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports